import React from 'react';
import { motion } from 'framer-motion';
import { track, PRODUCT } from '../lib/fpixel';
interface ButtonProps {
  children: React.ReactNode;
  className?: string;
  /** When true, the button goes straight to the checkout in a new tab. Otherwise it scrolls to the offer section. */
  toCheckout?: boolean;
}
const CHECKOUT_URL = 'https://glukolibreargentina.impultienda.ar/checkout';
export function Button({
  children,
  className = '',
  toCheckout = true
}: ButtonProps) {
  // Intense green, large, premium shadow
  const baseClasses = `inline-flex items-center justify-center w-full sm:w-auto px-8 md:px-12 py-5 md:py-6 text-xl md:text-2xl font-black text-white bg-[#16a34a] hover:bg-[#15803d] rounded-2xl shadow-[0_8px_30px_rgb(22,163,74,0.4)] transition-all duration-300 text-center uppercase tracking-wide ${className}`;
  const handleCheckout = () => {
    track('InitiateCheckout', {
      content_name: PRODUCT.content_name,
      content_category: PRODUCT.content_category,
      value: PRODUCT.value,
      currency: PRODUCT.currency
    });
  };
  return <motion.a href={CHECKOUT_URL} target="_blank" rel="noopener noreferrer" onClick={handleCheckout} whileHover={{
    scale: 1.03,
    y: -2
  }} whileTap={{
    scale: 0.97
  }} className={baseClasses} data-id="element-19">
      {children}
    </motion.a>;
}